import React, { PropTypes } from 'react'
import CSSModules from 'react-css-modules'

import styles from './event-type-selector-list.css'

const EventTypeSelectorList = ({ onChange, types, value }) => (
  <ul styleName="list">
    {types.map(type =>
      <li key={type.id} styleName="option">
        <input checked={value === type.id} onChange={() => onChange(type.id)} styleName="radio" type="radio" />
        {type.title}
      </li>
    )}
  </ul>
)

EventTypeSelectorList.propTypes = {
  onChange: PropTypes.func,
  types: PropTypes.array,
  value: PropTypes.number,
}

export default CSSModules(EventTypeSelectorList, styles)



/** WEBPACK FOOTER **
 ** ./src/components/setupform-form/field/event-type-selector/event-type-selector-list/event-type-selector-list.js
 **/